// The waitlist's one call (docs/plans/waitlist.md). It works signed out.
import type { WaitlistJoined } from '@shared/api';
import { sourceSchema, type WaitlistJoin } from '@shared/waitlist';
import { api } from '@/lib/api';

export function joinWaitlist(join: WaitlistJoin): Promise<WaitlistJoined> {
  return api<WaitlistJoined>('/waitlist', { method: 'POST', body: JSON.stringify(join) });
}

/** Where this visitor came from, from the link they opened: ?ref=youtube, or ?utm_source=youtube. */
export function sourceFromLink(search: string): string | undefined {
  const params = new URLSearchParams(search);
  const parsed = sourceSchema.safeParse(params.get('ref') ?? params.get('utm_source') ?? '');
  return parsed.success ? parsed.data : undefined;
}
